import { IOrganization, ISprint } from 'store/entities/organizations/interfaces/common.interfaces'
import { fromJS, List, Map, Record } from 'immutable'
import { ISOsForOrganizationSettings } from 'app/constants/phoneCountryCodes'

export const OneSignal = Record({
  appId: null, // null if OneSignal not exists
  link: null, // null if OneSignal not exists
  messageablePlayers: null,
  players: null,
})

export const CountriesCodes = Record(ISOsForOrganizationSettings)

export const Sprint = Record<ISprint>({
  achievedPoints: null,
  afterEndMessage: null,
  badge: null,
  badgeTitle: null,
  beforeEndMessage: null,
  createdAt: new Date(),
  start: new Date(),
  end: new Date(),
  firstDayMessage: null,
  id: null,
  isFinished: false,
  orgGoalAchievedMessage: null,
  organizationGoal: null,
  organizationId: null,
  title: null,
  updatedAt: new Date(),
  userGoal: null,
  userGoalAchievedMessage: null,
  isStarted: false,
})

export const OrganizationRecord = Record<IOrganization>({
  id: null,
  name: null,
  logo: null,
  label: null,
  labelId: null,
  domain: null,
  active: false,
  activeUsers: 0,
  users: List(),
  // ToDo: delete proTracks after merging to dev and testing
  proTracks: List(),
  proTracksLevels: List(),
  proTracksLibrariesLevels: List(),
  createdAt: null,
  updatedAt: null,
  holidaysList: List(),
  emailLogo: null,
  emailLogoWidth: 59,
  inactiveNotificationsPeriod: null,
  demoMode: false,
  useEmbeddedImages: false,
  teamOnly: false,
  hasIrregularWorkWeek: false,
  oneSignal: new OneSignal(),
  proTrackLevelEndsByActivityCount: false,
  sms: false,
  feedbackReviews: false,
  teams: List(),
  stories: false,
  reactions: false,
  reviews: false,
  isApiKeyEnabled: false,
  emailFrom: null,
  emailProviderApiKey: null,
  displayName: null,
  reviewsSurveyId: null,
  welcomeEmail: Map(),
  loaded: null,
  peerInvites: false,
  microactions: false,
  language: null,
  countriesCodes: new CountriesCodes(),
  isChildrenOrganizationExists: false,
  isMultiAdminExists: false,
  levelsChanges: Map(),
  partnersLinks: List(),
  isSprintsActive: false,
  sprints: List(),
  changeNotificationFrequency: false,
  isPreTrackSurveyEnabled: false,
  isPostTrackSurveyEnabled: false,
  social: false,
  sprint: new Sprint(),
  orgWorkWeek: List(),
  tenantId: null,
  type: null,
})

export class Organization extends OrganizationRecord {
  prepare() {
    let newInstance = this
    if (!(this.proTracks instanceof List)) {
      newInstance = newInstance.set('proTracks', fromJS(this.proTracks))
    }
    return newInstance
  }
}
